import React from 'react';

const DeleteHouseConnection = ({ flagVisibleHouse, dataConnectionHouse }) => {
  
    return (
      <div style={{ justifyContent: 'center' }}>
        <label style={{ color: '#dfab01', display: flagVisibleHouse ? 'block' : 'none', fontSize: '18px' }}>Связи</label>
  
        {flagVisibleHouse && dataConnectionHouse.length > 0 && (
          <>
            {dataConnectionHouse.some(item => item.couplingLocationId !== null) && (
              <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
                <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./сoupling.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: '18px' }}>Муфта</label>
                <hr className='horizontalLine2Modal' />
                {dataConnectionHouse.map((item, index) => (
                  item.couplingLocationId !== null && (
                    <div className='divBodyConnectModal' key={index}>
                      <span style={{ fontWeight: 'bold' }}>ID: {item.couplingLocationId}</span>
                      <br />
                      <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>
                    </div>
                  )
                ))}
              </div>
            )}
          </>
        )}
  
        {flagVisibleHouse && dataConnectionHouse.length > 0 && (
          <>
            {dataConnectionHouse.some(item => item.fobLocationId !== null) && (
              <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
                <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./fob.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: '18px' }}>Фоб</label>
                <hr className='horizontalLine2Modal' />
                {dataConnectionHouse.map((item, index) => (
                  item.fobLocationId !== null && (
                    <div className='divBodyConnectModal' key={index}>
                      <span style={{ fontWeight: 'bold' }}>ID: {item.fobLocationId}</span>
                      <br />
                      <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>
                    </div>
                  )
                ))}
              </div>
            )}
          </>
        )}
  
        {flagVisibleHouse && dataConnectionHouse.length > 0 && (
          <>
            {dataConnectionHouse.some(item => item.ponBoxLocationId !== null) && (
              <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
                <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./ponbox.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: '18px' }}>Пон-бокс</label>
                <hr className='horizontalLine2Modal' />
                {dataConnectionHouse.map((item, index) => (
                  item.ponBoxLocationId !== null && (
                    <div className='divBodyConnectModal' key={index}>
                      <span style={{ fontWeight: 'bold' }}>ID: {item.ponBoxLocationId}</span>
                      <br />
                      <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.ponBoxLatitude}, {item.ponBoxLongitude}</span>
                    </div>
                  )
                ))}
              </div>
            )}
          </>
        )}
  
        {flagVisibleHouse && dataConnectionHouse.length > 0 && (
          <>
            {dataConnectionHouse.some(item => item.highwayLineId !== null) && (
              <div className='divStartEndCableModal' style={{ marginTop: '10px' }}>
                <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src='./cable.png' alt='вектор' />
                <label style={{ color: '#dfab01', fontSize: '18px' }}>Кабель</label>
                <hr className='horizontalLine2Modal' />
                {dataConnectionHouse.map((item, index) => (
                  item.highwayLineId !== null && (
                    <div className='divBodyConnectModal' key={index}>
                      <span style={{ fontWeight: 'bold' }}>ID: {item.highwayLineId}</span>
                    </div>
                  )
                ))}
              </div>
            )}
          </>
        )}
      </div>
    );
  };
export default DeleteHouseConnection;